import createAxiosInstance from './axiosConfig';
import { EsteiraModelo } from '../shared/model/esteira_modelo';
import { FiltroSimplesDTO } from '../shared/dto/filtroSimplesDTO';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/esteiraModeloController');

export default class EsteiraModeloService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarTodasEsteirasModeloPaginado(currentPage: number, max: number, dto: FiltroSimplesDTO) {
    return await this.axios.post(`/listarTodasEsteirasModeloPaginado?page=${currentPage}&max=${max}`, dto);
  };

  async listarTodasEsteirasModelo() {
    return await this.axios.get(`/listarTodasEsteirasModelo`);
  };

  async listarEsteirasModeloAtivas() {
    return await this.axios.get(`/listarEsteirasModeloAtivas`);
  };

  async incluirAlterarEsteiraModelo(dto: EsteiraModelo) {
    return await this.axios.post(`/incluirAlterarEsteiraModelo`, dto);
  };

  async ativarInativarEsteira(id: string) {
    return await this.axios.get(`/ativarInativarEsteira?id=${id}`);
  };

}